module.exports = __webpack_public_path__ + "img/medical-industry.9e6fca42.png";